import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["order_id"];
import React from "react";
var __jsx = React.createElement;
import { createContext, useContext, useEffect, useState } from "react";
import { api__createOrder, api__createOrderV2, api__getOrderDetailsByParams, api__getOrderWithPaymentInfo, api__getOrderWithPaymentInfoV2, api__getShopApplyOrderV2, api__getPromoCode, api__getPromoCodeV2 } from "@/apis/orders/orders";
import ReservedPostException from "@/exceptions/postExceptions/ReservedPostException";
import useHelpers from "@hooks/useHelpers";
import { dispatchButtonLoading } from "@hooks/useButtonLoading";
import { ValidationException } from "@/common/exceptions/ValidationException";
import { normalizeIdNumber } from "@/utils/stringHelpers";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import useBoolean from "@hooks/useBoolean";
import useIsMobile from "@hooks/useIsMobile";
export var PURCHASE_METHOD_CASH = "cash";
export var PURCHASE_METHOD_NORMAL_FINANCE = "normal_finance";
export var PURCHASE_METHOD_TAMRA = "tamra";
export var PURCHASE_METHOD_ARIB = "arib";
export var PURCHASE_METHOD_TABBY = "tabby";
export var PURCHASE_METHOD_AMWAL = "amwaal";
export var PURCHASE_METHOD_CREDIT_CARD = "credit_card";
var extractQueryParams = function extractQueryParams() {
  var _searchParams$get, _searchParams$get2;
  var searchParams = new URLSearchParams(__IS_CSR__ ? window.location.search : "");
  var post_id = Number(searchParams.get('post_id')) || Number(searchParams.get('postId'));
  var order_id = normalizeIdNumber(searchParams.get("id"));
  if (!order_id) {
    order_id = normalizeIdNumber(searchParams.get("order_id"));
  }
  var is_test_order = ((_searchParams$get = searchParams.get("id")) === null || _searchParams$get === void 0 ? void 0 : _searchParams$get.includes("test")) || ((_searchParams$get2 = searchParams.get("order_id")) === null || _searchParams$get2 === void 0 ? void 0 : _searchParams$get2.includes("test"));
  var customerid = searchParams.get('customerid');
  var referral = searchParams.get('referral');
  var hasTawuniyaParams = customerid && referral;
  return {
    order_id: order_id,
    post_id: post_id,
    is_test_order: is_test_order,
    hasTawuniyaParams: hasTawuniyaParams,
    customerid: customerid,
    referral: referral
  };
};
var getFormDataDefault = function getFormDataDefault(user) {
  var checkoutOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return {
    full_name: (user === null || user === void 0 ? void 0 : user.full_name) || "",
    city_id: (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.city_id) || null,
    phone_number: (user === null || user === void 0 ? void 0 : user.phone_number) || "",
    whatsapp_optin: 1,
    code: null
  };
};
var getCurrentQueryParams = function getCurrentQueryParams() {
  return extractQueryParams();
};

// Only the shop-apply page owns the promo/warranty form — other pages (e.g.
// create-araboon) reuse the same context with different query-param handling.
var isShopApplyPage = function isShopApplyPage() {
  return typeof window !== "undefined" && window.location.pathname.includes("/checkout/shop-apply");
};

// pre-checkout needs credit_card to decide/show the credit-card payment option
var isPreCheckoutPage = function isPreCheckoutPage() {
  return typeof window !== "undefined" && window.location.pathname.includes("/pre-checkout");
};

// per-flow persist key: cash (shop-apply) keeps its own key; pages that are neither
// (pre-checkout, create-araboon, etc.) get a neutral key so they never accidentally read
// warranty/city saved by another flow and relay it to the API.
// NOTE: the credit-card flow owns its state in CreditCardCheckoutContext, not here.
var getCheckoutFormStorageKey = function getCheckoutFormStorageKey(postId) {
  if (isShopApplyPage()) return "shop_apply_form_data_".concat(postId);
  return "checkout_form_data_".concat(postId);
};
var CheckoutOrderContext = /*#__PURE__*/createContext(null);
export function useCheckoutOrder() {
  return useContext(CheckoutOrderContext);
}
export default function CheckoutOrderContextProvider(_ref) {
  var children = _ref.children;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var location = useLocation();
  var _useSession = useSession(),
    user = _useSession.user;
  var _useState = useState(extractQueryParams()),
    queryParams = _useState[0],
    setQueryParams = _useState[1];
  var _useState2 = useState(null),
    referralData = _useState2[0],
    setReferralData = _useState2[1];
  var _useState3 = useState(),
    checkoutOrder = _useState3[0],
    setCheckoutOrder = _useState3[1];
  var _useState4 = useState(null),
    checkoutOrderV2 = _useState4[0],
    setCheckoutOrderV2 = _useState4[1];
  var _useState5 = useState(false),
    fetch_loading = _useState5[0],
    setFetch_loading = _useState5[1];
  var _useState6 = useState(null),
    fetching_error = _useState6[0],
    setFetching_error = _useState6[1];
  var _useState7 = useState(null),
    formValidationException = _useState7[0],
    setFormValidationException = _useState7[1];
  var _useState8 = useState(""),
    purchaseMethod = _useState8[0],
    setPurchaseMethod = _useState8[1];
  var _useState9 = useState(null),
    showCampaignModal = _useState9[0],
    setShowCampaignModal = _useState9[1];
  var _useState0 = useState(false),
    showStory = _useState0[0],
    setShowStory = _useState0[1];
  var _useState1 = useState(function () {
      return getFormDataDefault(user);
    }),
    formData = _useState1[0],
    setFormData = _useState1[1];
  var financeModal = useBoolean();
  var isMobile = useIsMobile();
  var action__initFormData = function action__initFormData() {
    setQueryParams(extractQueryParams());
    setFormData(getFormDataDefault(user, checkoutOrder));
    setReferralData(null);
    setFormValidationException(null);
    setFetching_error(null);
  };
  var action__setPurchaseMethod = function action__setPurchaseMethod(method) {
    setPurchaseMethod(method);
  };
  var action__setShowCampaignModal = function action__setShowCampaignModal(value) {
    setShowCampaignModal(value);
  };
  var action__setShowStory = function action__setShowStory(value) {
    setShowStory(value);
  };
  useEffect(function () {
    if (queryParams !== null && queryParams !== void 0 && queryParams.post_id) {
      var _formData$warranty_id;
      var currentQueryParams = getCurrentQueryParams();
      var savedCityId;
      var savedCode;
      var savedWarrantyId;
      var savedReferralData = null;
      try {
        var saved = sessionStorage.getItem(getCheckoutFormStorageKey(currentQueryParams.post_id));
        if (saved) {
          var parsed = JSON.parse(saved);
          savedCityId = parsed.city_id ? Number(parsed.city_id) : undefined;
          savedCode = parsed.code || undefined;
          savedWarrantyId = parsed.warranty_id || undefined;
          savedReferralData = parsed.referralData || null;
        }
      } catch (_unused) {}
      if (savedReferralData) setReferralData(savedReferralData);
      fetch__getOrderDetailsByParamsV2(currentQueryParams.post_id, {
        order_id: currentQueryParams.order_id || undefined,
        city_id: savedCityId || (formData !== null && formData !== void 0 && formData.city_id ? Number(formData.city_id) : undefined),
        code: savedCode || formData.code,
        warranty_id: savedWarrantyId || ((_formData$warranty_id = formData === null || formData === void 0 ? void 0 : formData.warranty_id) !== null && _formData$warranty_id !== void 0 ? _formData$warranty_id : undefined)
      });
    }
  }, [queryParams === null || queryParams === void 0 ? void 0 : queryParams.post_id, queryParams === null || queryParams === void 0 ? void 0 : queryParams.order_id]);
  useEffect(function () {
    if (checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.referral_code && !formData.code) {
      setFormItem('code', checkoutOrder.referral_code);
      fetch__getPromoCode(checkoutOrder.referral_code);
    }
  }, [checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.referral_code]);
  useEffect(function () {
    setQueryParams(extractQueryParams());
  }, [location]);
  var setFormItem = function setFormItem(key, value) {
    setFormData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, value));
    });
  };
  var action__resetPromoCode = function action__resetPromoCode() {
    var _formData$warranty_id2;
    setFormItem('code', null);
    setReferralData(null);
    try {
      var post_id = getCurrentQueryParams().post_id;
      if (post_id) {
        var key = getCheckoutFormStorageKey(post_id);
        var existing = JSON.parse(sessionStorage.getItem(key) || '{}');
        delete existing.referralData;
        sessionStorage.setItem(key, JSON.stringify(existing));
      }
    } catch (_unused2) {}
    var currentQueryParams = getCurrentQueryParams();
    fetch__getOrderDetailsByParamsV2(currentQueryParams.post_id, {
      order_id: currentQueryParams.order_id || undefined,
      city_id: formData !== null && formData !== void 0 && formData.city_id ? Number(formData.city_id) : undefined,
      warranty_id: (_formData$warranty_id2 = formData === null || formData === void 0 ? void 0 : formData.warranty_id) !== null && _formData$warranty_id2 !== void 0 ? _formData$warranty_id2 : undefined
    });
  };
  var fetch__getOrderDetailsByParams = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var override,
        _omitOrderId,
        queryParamsWithoutOrderId,
        params,
        order,
        _args = arguments;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            override = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            // SE-11902: get-details by-params is pre-order (cash/shop-apply) — must not send a committed order_id
            // SE-11902: only shop-apply (pre-order, cash) must not send a committed order_id;
            // order-based pages (create-araboon, etc.) still need it for get-details.
            _omitOrderId = queryParams.order_id, queryParamsWithoutOrderId = _objectWithoutProperties(queryParams, _excluded);
            params = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, isShopApplyPage() ? queryParamsWithoutOrderId : queryParams), !referralData || !referralData.status ? {
              code: ''
            } : {}), formData), {}, {
              post_id: queryParams.post_id
            }, override);
            setFetch_loading(true);
            _context.p = 1;
            _context.n = 2;
            return api__getOrderDetailsByParams(params);
          case 2:
            order = _context.v;
            setCheckoutOrder(order);
          case 3:
            _context.p = 3;
            setFetch_loading(false);
            return _context.f(3);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1,, 3, 4]]);
    }));
    return function fetch__getOrderDetailsByParams() {
      return _ref2.apply(this, arguments);
    };
  }();
  var fetch__getOrderDetailsByParamsV2 = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(post_id, params, onSuccess) {
      var data, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            setFetch_loading(true);
            _context2.n = 1;
            return api__getShopApplyOrderV2(post_id, params, isMobile);
          case 1:
            data = _context2.v;
            setCheckoutOrderV2(data);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t = _context2.v;
            setFetching_error(_t);
          case 3:
            _context2.p = 3;
            setFetch_loading(false);
            return _context2.f(3);
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2, 3, 4]]);
    }));
    return function fetch__getOrderDetailsByParamsV2(_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var fetch__getOrderWithPaymentInfoV2 = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(post_id, params) {
      var data, _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            setFetch_loading(true);
            _context3.n = 1;
            return api__getOrderWithPaymentInfoV2(post_id, params);
          case 1:
            data = _context3.v;
            setCheckoutOrderV2(data);
            _context3.n = 3;
            break;
          case 2:
            _context3.p = 2;
            _t2 = _context3.v;
            setFetching_error(_t2);
          case 3:
            _context3.p = 3;
            setFetch_loading(false);
            return _context3.f(3);
          case 4:
            return _context3.a(2);
        }
      }, _callee3, null, [[0, 2, 3, 4]]);
    }));
    return function fetch__getOrderWithPaymentInfoV2(_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
  var fetch__getOrderWithPaymentInfo = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(post_id, order_id) {
      var order, _t3;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            _context4.p = 0;
            setFetch_loading(true);
            _context4.n = 1;
            return api__getOrderWithPaymentInfo(user === null || user === void 0 ? void 0 : user.id, order_id, post_id, isPreCheckoutPage() ? ["credit_card"] : undefined);
          case 1:
            order = _context4.v;
            setCheckoutOrder(order);
            _context4.n = 4;
            break;
          case 2:
            _context4.p = 2;
            _t3 = _context4.v;
            if (!(_t3 instanceof ReservedPostException)) {
              _context4.n = 3;
              break;
            }
            return _context4.a(2, navigateTo("/cardetail/".concat(_t3.post_id, "?ref=car_reserved")));
          case 3:
            setFetching_error(_t3);
          case 4:
            _context4.p = 4;
            setFetch_loading(false);
            return _context4.f(4);
          case 5:
            return _context4.a(2);
        }
      }, _callee4, null, [[0, 2, 4, 5]]);
    }));
    return function fetch__getOrderWithPaymentInfo(_x6, _x7) {
      return _ref5.apply(this, arguments);
    };
  }();
  var fetch__getPromoCode = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(code) {
      var promData, post_id, key, existing, _t4;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            _context5.p = 0;
            setFetch_loading(true);
            _context5.n = 1;
            return api__getPromoCode({
              code: code,
              post_id: queryParams === null || queryParams === void 0 ? void 0 : queryParams.post_id,
              city_id: (formData === null || formData === void 0 ? void 0 : formData.city_id) || null
            });
          case 1:
            promData = _context5.v;
            setReferralData(promData);
            try {
              post_id = queryParams === null || queryParams === void 0 ? void 0 : queryParams.post_id;
              if (post_id) {
                key = getCheckoutFormStorageKey(post_id);
                existing = JSON.parse(sessionStorage.getItem(key) || '{}');
                sessionStorage.setItem(key, JSON.stringify(_objectSpread(_objectSpread({}, existing), {}, {
                  referralData: promData
                })));
              }
            } catch (_unused3) {}
            return _context5.a(2, promData);
          case 2:
            _context5.p = 2;
            _t4 = _context5.v;
            setFetching_error(_t4);
          case 3:
            _context5.p = 3;
            setFetch_loading(false);
            return _context5.f(3);
          case 4:
            return _context5.a(2);
        }
      }, _callee5, null, [[0, 2, 3, 4]]);
    }));
    return function fetch__getPromoCode(_x8) {
      return _ref6.apply(this, arguments);
    };
  }();
  var fetch__getPromoCodeV2 = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(code) {
      var promData, post_id, key, existing, _t5;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            _context6.p = 0;
            setFetch_loading(true);
            _context6.n = 1;
            return api__getPromoCodeV2({
              code: code,
              post_id: queryParams === null || queryParams === void 0 ? void 0 : queryParams.post_id,
              city_id: (formData === null || formData === void 0 ? void 0 : formData.city_id) || null
            });
          case 1:
            promData = _context6.v;
            setReferralData(promData);
            try {
              post_id = queryParams === null || queryParams === void 0 ? void 0 : queryParams.post_id;
              if (post_id) {
                key = getCheckoutFormStorageKey(post_id);
                existing = JSON.parse(sessionStorage.getItem(key) || '{}');
                sessionStorage.setItem(key, JSON.stringify(_objectSpread(_objectSpread({}, existing), {}, {
                  referralData: promData
                })));
              }
            } catch (_unused4) {}
            return _context6.a(2, promData);
          case 2:
            _context6.p = 2;
            _t5 = _context6.v;
            setFetching_error(_t5);
          case 3:
            _context6.p = 3;
            setFetch_loading(false);
            return _context6.f(3);
          case 4:
            return _context6.a(2);
        }
      }, _callee6, null, [[0, 2, 3, 4]]);
    }));
    return function fetch__getPromoCodeV2(_x9) {
      return _ref7.apply(this, arguments);
    };
  }();
  var fetch__createOrder = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var currentQueryParams, toBeSendParams, newOrder, _t6;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            currentQueryParams = getCurrentQueryParams();
            toBeSendParams = _objectSpread(_objectSpread(_objectSpread({}, currentQueryParams), formData), {}, {
              examine_date: ''
            });
            delete toBeSendParams["code"];
            if (referralData && referralData.status) {
              toBeSendParams["referral_code_id"] = String(referralData.reward.code_id);
            }
            dispatchButtonLoading(true);
            _context7.p = 1;
            _context7.n = 2;
            return api__createOrder(toBeSendParams);
          case 2:
            newOrder = _context7.v;
            setCheckoutOrder(newOrder);
            return _context7.a(2, newOrder);
          case 3:
            _context7.p = 3;
            _t6 = _context7.v;
            if (!(_t6 instanceof ValidationException)) {
              _context7.n = 4;
              break;
            }
            return _context7.a(2, setFormValidationException(_t6));
          case 4:
            console.log('error', _t6);
            toast.error(_t6.message);
            throw _t6;
          case 5:
            _context7.p = 5;
            dispatchButtonLoading(false);
            return _context7.f(5);
          case 6:
            return _context7.a(2);
        }
      }, _callee7, null, [[1, 3, 5, 6]]);
    }));
    return function fetch__createOrder() {
      return _ref8.apply(this, arguments);
    };
  }();
  var fetch__createOrderV2 = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
      var currentQueryParams, toBeSendParams, newOrder, _t7;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            currentQueryParams = getCurrentQueryParams();
            toBeSendParams = _objectSpread(_objectSpread({}, currentQueryParams), formData);
            dispatchButtonLoading(true);
            _context8.p = 1;
            _context8.n = 2;
            return api__createOrderV2(toBeSendParams);
          case 2:
            newOrder = _context8.v;
            return _context8.a(2, newOrder);
          case 3:
            _context8.p = 3;
            _t7 = _context8.v;
            if (!(_t7 instanceof ValidationException)) {
              _context8.n = 4;
              break;
            }
            setFormValidationException(_t7);
            return _context8.a(2, null);
          case 4:
            console.log('error', _t7);
            toast.error(_t7.message);
            throw _t7;
          case 5:
            _context8.p = 5;
            dispatchButtonLoading(false);
            return _context8.f(5);
          case 6:
            return _context8.a(2);
        }
      }, _callee8, null, [[1, 3, 5, 6]]);
    }));
    return function fetch__createOrderV2() {
      return _ref9.apply(this, arguments);
    };
  }();

  /** Collections **/
  var actions = {
    setCheckoutOrder: setCheckoutOrder,
    setFormItem: setFormItem,
    action__resetPromoCode: action__resetPromoCode,
    action__initFormData: action__initFormData,
    action__setPurchaseMethod: action__setPurchaseMethod,
    action__setShowCampaignModal: action__setShowCampaignModal,
    action__setShowStory: action__setShowStory
  };
  var remote_actions = {
    fetch__getOrderWithPaymentInfo: fetch__getOrderWithPaymentInfo,
    fetch__getOrderDetailsByParams: fetch__getOrderDetailsByParams,
    fetch__getPromoCode: fetch__getPromoCode,
    fetch__getPromoCodeV2: fetch__getPromoCodeV2,
    fetch__createOrder: fetch__createOrder,
    fetch__createOrderV2: fetch__createOrderV2,
    fetch__getOrderWithPaymentInfoV2: fetch__getOrderWithPaymentInfoV2,
    fetch__getOrderDetailsByParamsV2: fetch__getOrderDetailsByParamsV2
  };
  var state = {
    checkoutOrder: checkoutOrder,
    checkoutOrderV2: checkoutOrderV2,
    fetch_loading: fetch_loading,
    fetching_error: fetching_error,
    formData: formData,
    referralData: referralData,
    formValidationException: formValidationException,
    purchaseMethod: purchaseMethod,
    showCampaignModal: showCampaignModal,
    showStory: showStory,
    financeModal: financeModal
  };
  return /*#__PURE__*/React.createElement(CheckoutOrderContext.Provider, {
    value: {
      actions: actions,
      remote_actions: remote_actions,
      state: state,
      queryParams: queryParams
    }
  }, children);
}